import 'containers/SmWorkbench/ProjectDetail/Show/Detail/Bottom/PendingQuote/index.less';
import * as React from 'react';
import PropTypes from 'prop-types';
import classnamesBind from 'classnames/bind';
import { Button, Table, InputNumber, Form, Upload, Select, Input } from '@beehive/components';
import { TabContent } from 'containers/SmWorkbench/ProjectDetail/Show/Detail/Bottom/components';
import { isBlank, showAlert, beforeUploadSuccess } from 'utils';
import classnames from 'classnames';
import { financial } from 'utils/number';
import _ from 'lodash';
import messages from 'messages/Workbench/ProjectDetail';
import { getCooperateAccountsQuoteData, getTranslatedFormItem } from 'containers/SmWorkbench/ProjectDetail/utils';
import { UploadFile } from 'modules/types/commons/file';
import { hasGrayConfigWithoutGroup } from 'utils/gray';
import { getAttachementUploadUrl } from 'containers/OutWorkbench/utils';
import { isAdsXiaohao } from './utils';
import { Tag, Checkbox, Button as BCButton, Space, Alert, Message, Tooltip } from '@bedrock/components';
import { HistoryModalClick } from '@mpc/common/src/features/HistoryQuoteModal/bc';
import NewPendingQuote from '@mpc/common/src/features/NewPendingQuote';
import s from './index.less';
import { AlertCircleFilled, Check, ChevronRight, Close, HelpCircle } from '@bedrock/icons-react';
import StatementModal from 'containers/OutWorkbench/components/StatementModal';
import { $sType, getVendorStorage, tableColumnWidthToRem } from '@mpc/common/src/utils';
import DescriptionsFormItem from '@mpc/common/src/components/DescriptionsFormItem';
import TextDisplay from '@mpc/common/src/components/TextDisplay';
import ReasonMdodal from '@mpc/common/src/components/ReasonModal';
import { ChannelSupplierBankDto, outsourceDemandMoveMove, outsourceNewSupplierQueryVmdmBankAccount } from 'services/api';

export interface PendingQuoteProps {
  tabKey: string;
}

const xc = classnamesBind.bind(s);

const TABLE_COLUMNS = [
  { key: 'index', title: 'index', align: 'left', width: 120 },
  { key: 'platform', title: 'superior_resource_id', align: 'left' },
  { key: 'account', title: 'account', align: 'left' },
  { key: 'remark', title: 'remark', align: 'left' },
  {
    key: 'pre_quote_price',
    title: '上一轮报价金额',
    align: 'left',
    width: 164,
    show(detal: any) {
      // 有上一轮报价金额,只有多轮报价才显示
      return detal.turns_number > 1;
    },
  },
  { key: 'quote_price', title: 'quote_price_rmb', align: 'left', width: 164 },
  { key: 'currency', title: 'currency', align: 'left', width: 164 },
];

const FULL_COL_PROPS = {
  itemColProps: { span: 24 },
  itemLabelColProps: { span: 4 },
  itemInputColProps: { span: 20 },
};
export const FormProps = {
  mode: 'edit',
  isLabelVertical: false,
  showClientError: false,
  checkMinHeight: false,
  ...FULL_COL_PROPS,
};
const FormItems = [
  {
    key: 'bid_attachs_blob_ids',
    label: 'bid_attachs',
    required: (detail: any) => {
      return detail.purchasing_strategy === 'MULTI_QUOTA';
    },
    childProps: {
      type: 'Upload',
      uploadKey: 'bid_attachs',
      showUploadList: { showRemoveIcon: true },
      multiple: true,
      uploadTips: 'uploadTips',
    },
  },
];
const MAX_SIZE_LIMIT = 1024 * 1024 * 200;

class PendingQuote extends React.Component<PendingQuoteProps, any> {
  private scrollbarRef: React.RefObject<any> = React.createRef();
  private quoteRef: React.RefObject<any> = React.createRef();
  public static contextTypes = {
    intl: PropTypes.object,
    prefixCls: PropTypes.string,
    menuKey: PropTypes.string,
    detail: PropTypes.any,

    loadDetail: PropTypes.func,
    projectMove: PropTypes.func,
  };

  currencyOptions = [];

  constructor(props: PendingQuoteProps, context: any) {
    super(props, context);

    const { intl, detail } = context;
    const form = getCooperateAccountsQuoteData(detail, intl, messages);
    // 后端返回货币枚举值
    this.currencyOptions = detail.options.quote_currencies;
    this.state = { form, attachs: [], submitting: false, newPendingQuoteParams: {}, visible: false, isSelected: false };
  }

  private handleSubmit = async () => {
    const { intl, menuKey, detail, loadDetail, projectMove } = this.context;
    const { form = [], attachs = [], newPendingQuoteParams, isSelected } = this.state;
    if (!isSelected) {
      this.setState({ visible: true });
      return;
    }
    const adsXiaohao = isAdsXiaohao(detail);
    const structured = detail?.structured;
    const params = form
      .filter((i: any) => !i.isTotal)
      .filter((i: any) => {
        if (adsXiaohao) {
          return !isBlank(i.program_desc);
        } else {
          return !isBlank(i.quote_price);
        }
      });

    if (!structured) {
      if (params.length <= 0) {
        showAlert({
          type: 'error',
          message: intl.formatMessage(messages.hasNoQuoteAlert),
        });
        return;
      }

      // 综合评分必填比选方案
      if (!attachs.length && detail.purchasing_strategy === 'MULTI_QUOTA') {
        showAlert({
          type: 'error',
          message: '请上传 供应商比选方案及相关文件',
        });
        return;
      }

      const hasNotSameCurrency = form.some((item: any) => {
        return !item.isTotal && item.currency !== form[0].currency;
      });

      if (hasNotSameCurrency) {
        showAlert({ type: 'error', message: '报价币种需要保持一致' });
        return;
      }
    }

    let submitBody: any = {
      id: detail.id,
      pending_quote: {
        is_pass: true,
        demand_suppliers_attributes: {
          id: detail.current_demand_supplier_id,
          is_quoted: true,
          demand_supplier_quotes_attributes: params.map((i: any) => {
            const item: any = {
              id: i.quote_id,
              cooperate_account_id: i.id,
            };
            if (adsXiaohao) {
              item.program_desc = i.program_desc;
            } else {
              item.quote_price = i.quote_price;
              item.currency = i.currency;
            }
            return item;
          }),
          bid_attachs_blob_ids: [...attachs],
        },
      },
    };

    if (hasGrayConfigWithoutGroup(['external.demand_flow.pending_quote'])) {
      if (structured) {
        const data = await this.quoteRef.current?.validateFields();
        const bid_attachs_blob_keys = data?.bid_attachs?.map((item: any) => item.blob?.key);
        const merge_quote_attach_blob_keys =
          detail?.quote_upload_method === 'MULTI_UPLOAD'
            ? data?.merge_quote_attachs?.map((item: any) => item.blob?.blob_key || item.blob?.key)
            : undefined;
        const value = newPendingQuoteParams;

        submitBody = {
          id: detail.id,
          state: 'pending_quote',
          pass: true,
          form: {
            id: detail.id,
            demand_supplier: {
              ...value,
              demand_supplier_quotes:
                value?.demand_supplier_quotes
                  ?.filter((item: any) => item.ableQuote)
                  ?.map((v) => {
                    return {
                      ...v,
                      necessary_rights: v?.cooperate_account?.necessary_rights,
                      expect_rights: v?.cooperate_account?.expect_rights,
                    };
                  }) || [],
              is_quoted: true,
              id: detail.current_demand_supplier_id,
              bid_attachs_blob_keys,
              merge_quote_attach_blob_keys,
            },
          },
        };
      } else {
        submitBody = {
          id: detail.id,
          state: 'pending_quote',
          pass: true,
          form: {
            id: detail.id,
            demand_supplier: {
              id: detail.current_demand_supplier_id,
              is_quoted: true,
              demand_supplier_quotes: params.map((i: any) => {
                const item: any = {
                  id: i.quote_id,
                  cooperate_account_id: i.id,
                };
                if (adsXiaohao) {
                  item.program_desc = i.program_desc;
                } else {
                  item.quote_price = i.quote_price;
                  item.currency = i.currency;
                }
                return item;
              }),
              bid_attachs_blob_keys: attachs.map((a: any) => a.blob_key),
            },
          },
        };
      }
    }
    this.setState({ submitting: true });
    return projectMove(submitBody, { menuKey })
      .then((res: any) => {
        showAlert({ type: 'success', message: res.res_msg });
        this.setState({ submitting: false });
        loadDetail();
      })
      .catch((error: any) => {
        showAlert({
          type: 'error',
          message: typeof error === 'string' ? error : error.message,
        });
        this.setState({ submitting: false });
      });
  };

  handleRejectOrder = async (v: { reason?: string }) => {
    const { loadDetail, detail } = this.context as any;
    await outsourceDemandMoveMove({
      id: detail?.id,
      state: detail?.state,
      pass: false,
      form: {
        id: detail.id,
        reason: v?.reason,
        demand_supplier: { id: detail.current_demand_supplier_id },
      },
    }).then(() => {
      Message.success('操作成功');
    });
    loadDetail?.();
  };

  private getTotalPrice = (data: any[]) => {
    const total = data
      .filter((i: any) => !i.isTotal)
      .reduce((prev: number, curr: any) => {
        const price = curr['quote_price'];
        prev = _.add(prev, isBlank(price) ? 0 : +price);
        return prev;
      }, 0);
    return total;
  };

  private handleBeforeUpload = (file: any) => {
    const { intl } = this.context;
    if (file.size && file.size > MAX_SIZE_LIMIT) {
      showAlert({
        type: 'error',
        message: intl.formatMessage(messages.fileExceededLimit, {
          filename: file.name,
          fileMaxSize: '200M',
        }),
      });
      return false;
    }
    return true;
  };

  private getUploadBody = (file: UploadFile, key: string) => {
    return {
      model: 'SocialMedia::ProjectSupplier',
      filename: file.name,
      attach_type: key,
    };
  };

  private handleUploadChange = (options: any, key: string) => {
    const { attachs = [] } = this.state;
    const { file } = options;
    const blob = _.get(file, 'response.data');
    let newAttaches = [...attachs];
    switch (file.status) {
      case 'done':
        newAttaches.push({ blob_id: blob.blob_id, blob_key: blob.blob_key });
        this.scrollbarRef.current && this.scrollbarRef.current.scrollToBottom();
        break;
      case 'removed':
        newAttaches = newAttaches.filter((a: any) => a.blob_id !== blob.blob_id);
        break;
      default:
        return;
    }
    this.setState({ attachs: newAttaches });
  };

  private handleChange = (key: string, index: number, value: any) => {
    const { form = [] } = this.state;
    const newForm = [...form];
    if (key === 'currency') {
      newForm.forEach((item) => {
        if (!item.isTotal) {
          item[key] = value;
        }
      });
    } else {
      newForm[index][key] = value;
    }
    const totalItem = newForm.find((item) => !!item.isTotal);
    if (totalItem) {
      totalItem['quote_price'] = this.getTotalPrice(newForm);
    }
    this.setState({ form: newForm });
  };

  private getColumnDefaultRender = () => {
    return (v: any, r: any, i: number) => {
      return isBlank(v) ? (r.isTotal ? '' : '--') : v;
    };
  };

  private renderFormItemChild = (itemProps: any, childProps: any) => {
    const { key } = itemProps;
    const { type, ...childPropsRest } = childProps;
    switch (type) {
      case 'Upload': {
        const { uploadKey, ...uploadPropsRest } = childPropsRest;
        return (
          <Upload
            {...uploadPropsRest}
            action={getAttachementUploadUrl()}
            beforeUpload={this.handleBeforeUpload}
            beforeSuccess={beforeUploadSuccess}
            data={(file: UploadFile) => this.getUploadBody(file, uploadKey)}
            onChange={(options: any) => this.handleUploadChange(options, key)}
          />
        );
      }
      default: {
        return <span />;
      }
    }
  };

  private getColumnRender = () => {
    const { intl } = this.context;
    return {
      index: (v: any, r: any, i: number) => {
        return r.isTotal ? intl.formatMessage(messages.quote_price_total) : isBlank(v) ? '--' : v;
      },
      // 上一轮报价金额
      pre_quote_price: (v: any, r: any, i: number) => {
        let currency = r.pre_quote_price_currency;
        let translatedCurrency = messages[`currency.${currency?.toLowerCase?.()}`];
        if (translatedCurrency) {
          currency = intl.formatMessage(translatedCurrency);
        }
        return isBlank(v) ? '--' : financial(v) + ' ' + currency;
      },
      quote_price: (v: any, r: any, i: number) => {
        if (r.isTotal) {
          return isBlank(v) ? '--' : financial(v);
        }
        return (
          <InputNumber
            hideHandle
            min={0}
            precision={2}
            placeholder={intl.formatMessage(messages.inputPlaceholder)}
            value={v}
            formatter={(val: any) => financial(val, true)}
            onChange={(value: any) => this.handleChange('quote_price', i, value)}
          />
        );
      },
      currency: (v: any, r: any, i: number) => {
        if (r.isTotal) {
          return '';
        }
        return (
          <Select
            mode="select"
            style={{ width: 120 }}
            options={this.currencyOptions}
            popupProps={{ getPopupContainer: undefined }}
            value={v}
            onChange={(value: any) => this.handleChange('currency', i, value)}
          />
        );
      },
      program_desc: (v: any, r: any, i: number) => {
        if (r.isTotal) {
          return '';
        }
        return (
          <Input.TextArea
            maxHeight={71}
            minHeight={32}
            maxLength={500}
            autosize
            value={v}
            onChange={(e: any) => this.handleChange('program_desc', i, e.target.value)}
          />
        );
      },
    };
  };

  private getColumns = () => {
    const { intl, detail } = this.context;
    const defaultRender = this.getColumnDefaultRender();
    const columRenders = this.getColumnRender();

    let columns = TABLE_COLUMNS.filter((v: any) => {
      if (typeof v.show === 'function') {
        return v.show(detail);
      }
      return true;
    });
    if (isAdsXiaohao(detail)) {
      columns = columns
        .filter((v: any) => {
          return !['quote_price', 'currency', 'pre_quote_price'].includes(v.key);
        })
        .map((v: any) => ({
          ...v,
          width: undefined,
        }));
      columns.push({
        key: 'program_desc',
        title: 'program_desc',
        align: 'left',
      });
    }
    return columns.map((item: any) => {
      return {
        ...tableColumnWidthToRem(item),
        dataIndex: item.key,
        title: messages[item.title] ? intl.formatMessage(messages[item.title]) : item.title,
        render: columRenders[item.key] || defaultRender,
        className: classnames({
          [item.key]: true,
        }),
      };
    });
  };

  private handleOpenModal = () => {
    this.setState({ visible: true });
  };

  private handleCheckBoxChange = (isSelected: boolean) => {
    this.setState({ isSelected });
  };
  private renderBottom = () => {
    const { intl } = this.context;
    const { submitting, isSelected } = this.state;
    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: 20,
        }}>
        <Space size={4}>
          <Checkbox
            checked={isSelected}
            onChange={(e) => {
              this.handleCheckBoxChange(e.target.checked);
            }}>
            我已阅读并同意
          </Checkbox>
          <BCButton type="link" onClick={this.handleOpenModal}>
            《报价声明》
          </BCButton>
        </Space>
        <div className="pull-right">
          <Space size="small">
            <BCButton
              danger
              icon={<Close />}
              loading={submitting}
              onClick={() => {
                ReasonMdodal.show({
                  title: '拒单',
                  okText: '确定拒单',
                  okButtonProps: { danger: true },
                  reasonLabel: '拒单原因',
                  headerPlace: (
                    <Alert
                      showIcon
                      type="warning"
                      message="确定拒绝此单吗?"
                      description="如确定拒绝此订单，需填写拒单原因以便我方知晓原因。"
                      className="m-b-20"
                    />
                  ),
                  onOk: this.handleRejectOrder,
                });
              }}>
              拒单
            </BCButton>
            <BCButton size="medium" type="primary" icon={<Check />} loading={submitting} onClick={this.handleSubmit}>
              {intl.formatMessage(messages.submit)}
            </BCButton>
          </Space>
        </div>
      </div>
    );
  };

  componentDidMount(): void {
    const { detail } = this.context;

    const newPendingQuoteParams = detail?.demand_suppliers?.[0] ?? {};
    const vendorId = getVendorStorage();
    if (
      !newPendingQuoteParams?.channel_supplier_bank_dto?.bank_business_code &&
      detail?.state?.toLowerCase?.() === 'pending_quote' &&
      $sType === 'outer' && vendorId?.vendorId
    ) {
      outsourceNewSupplierQueryVmdmBankAccount({ mdm_code: vendorId?.vendorId }).then((res) => {
        const data: ChannelSupplierBankDto[] = res?.data || [];
        if(data.length > 0) {
          newPendingQuoteParams.channel_supplier_bank_dto = data[0];
        }
        this.setState({ newPendingQuoteParams });
      });
    } else {
      this.setState({ newPendingQuoteParams});
    }
  }

  public render() {
    const { intl, detail, loadDetail } = this.context;
    const { tabKey } = this.props;
    const { form, visible } = this.state;
    const bottom = this.renderBottom();
    const columns = this.getColumns();

    const isStructuredQuote = detail?.structured && detail?.structured_version > 0;

    return (
      <TabContent tabKey={tabKey} bottom={bottom} canScroll ref={this.scrollbarRef}>
        {detail?.structured ? (
          <>
            <div className={xc('new-pending-quote-container-title')}>
              <Space size={8}>
                <span className={xc('title')}>{detail?.translated_purchasing_method}</span>
                <Tag size="xSmall" border={true} text={`${detail.turns_number}轮`} color="light-brand" />
                {detail.turns_number > 1 && !detail.$isAdsXiaohao && (
                  <HistoryModalClick
                    type={'sm'}
                    supplierName={''}
                    businessId={detail.id}
                    supplierId={detail.current_supplier_id}
                    detail={detail}
                    isStructured={detail.structured}>
                    <BCButton type="link" suffixIcon={<ChevronRight />}>
                      查看历史报价
                    </BCButton>
                  </HistoryModalClick>
                )}
                {detail?.support_ai_quote_flag && (
                  <div className="ml-6">
                    <span>
                      是否需整单报价
                      <Tooltip title="为「是」时整单全部合作内容均需报价；中选时需中选单个供应商全部合作内容">
                        <HelpCircle />
                      </Tooltip>
                      ：
                    </span>
                    <Tag
                      color={detail?.need_all_quote ? 'light-green' : 'light-grey'}
                      size="xSmall"
                      text={detail?.need_all_quote ? '是' : '否'}></Tag>
                  </div>
                )}
              </Space>
              <div className="flex gap-6">
                <div>
                  <span>截止时间：</span>
                  <span className={xc('title')}>{detail?.quote_deadline}</span>
                </div>
              </div>
            </div>
            {detail?.demand_suppliers?.[0]?.re_quotation_flag && (
              <Alert
                message="报价被退回，请在截止时间内重新报价"
                description={`退回原因：${detail?.demand_suppliers?.[0]?.re_quotation_reason || '--'}`}
                type="warning"
                showIcon
                style={{ marginBottom: 20 }}
              />
            )}
            {isStructuredQuote && (
              <Alert
                message="报价时请仔细阅读并确认本单 权益、验收标准。"
                type="error"
                icon={<AlertCircleFilled />}
                showIcon
                className="m-b-20"
              />
            )}
            {isStructuredQuote && (
              <DescriptionsFormItem
                className="m-b-20"
                items={[
                  {
                    formItemKey: 'accept_desc',
                    label: '验收通过要求',
                    componentClass: 'textarea',
                    required: false,
                    view: true,
                    span: 2,
                    elementProps: {
                      maxLength: 1000,
                      style: { width: '100%' },
                      showComponent: () => {
                        return <TextDisplay value={detail?.demand_plan_info?.accept_desc} />;
                      },
                    },
                  },
                ]}
              />
            )}
            <NewPendingQuote
              view={false}
              ref={this.quoteRef}
              detail={detail}
              value={this.state.newPendingQuoteParams}
              onChange={(value) => {
                this.setState({ newPendingQuoteParams: value });
              }}
              type="pendingQuote"
            />
          </>
        ) : (
          <>
            {detail.$flow_vision !== 'v0' && (
              <div className={xc('tab-header')}>
                <div className={xc('tab-header-left')}>
                  <div className={xc('item-wrapper')}>
                    {detail.translated_purchasing_method && (
                      <>
                        <span className={xc('label')}>采购方式：</span>
                        <span className={xc('value')}>{detail.translated_purchasing_method}</span>
                      </>
                    )}
                    {detail.turns_number && (
                      <Tag
                        border={true}
                        color={'light-brand'}
                        style={{ marginLeft: 4 }}
                        text={`${detail.turns_number} 轮`}
                      />
                    )}
                  </div>
                </div>
                <div className={xc('tab-header-right')}>
                  {detail.turns_number > 1 && !detail.$isAdsXiaohao && (
                    <HistoryModalClick
                      type={'sm'}
                      supplierName={''}
                      businessId={detail.id}
                      supplierId={detail.current_supplier_id}
                      detail={detail}
                      isStructured={detail.structured}>
                      <Button link>查看历史报价轮次</Button>
                    </HistoryModalClick>
                  )}
                </div>
              </div>
            )}
            <Table columns={columns} data={form} size="small" rowKey="index" />
            <Form {...FormProps}>
              {FormItems.map((item: any) => {
                const translatedItem = getTranslatedFormItem(item, intl, messages);
                const { childProps, ...itemProps } = translatedItem;
                // 处理 required 和 show
                ['required', 'show'].forEach((key) => {
                  if (typeof itemProps[key] === 'function') {
                    itemProps[key] = itemProps[key](detail);
                  }
                });
                return (
                  <Form.Item
                    {...itemProps}
                    key={itemProps.key}
                    itemKey={itemProps.formKey || itemProps.key}
                    className={itemProps.key}>
                    {this.renderFormItemChild(itemProps, childProps)}
                  </Form.Item>
                );
              })}
            </Form>
          </>
        )}
        <StatementModal
          visible={visible}
          onCancel={() => {
            this.setState({ visible: false, isSelected: false });
          }}
          onOk={() => {
            this.setState({ visible: false, isSelected: true }, () => {
              this.handleSubmit();
            });
          }}
        />
      </TabContent>
    );
  }
}

export default PendingQuote;
